import template from '../../view/people.html';
import exampleModel from '../model/people';

const COLORS = [
        '#FFCD2B',
        '#fc8d62',
        '#e78ac3',
        '#66c2a5',
        // '#a6d854',
        '#8da0cb'];

// const CATEGORIES = 

export default {
    data() {
        return {
            pkg: {
                version: PKG_VERSION
            },
            groups: []
        };
    },
    vuex: exampleModel,
    render: template.render,
    staticRenderFns: template.staticRenderFns,
    methods: {
    },
    mounted() {
        let vm = this;

        let categories = ['A','B','C','D','E'];

        vm.groups = [{
            code: 'BDAC',
            name: 'Broadband Deployment Advisory Committee'
        },{
            code: 'WG1',
            name: 'Competitive Access to Broadband Infrastructure'
        },{
            code: 'WG2',
            name: 'Removing State and Local Regulatory Barriers'
        },{
            code: 'WG3',
            name: 'Model Code for Municipalities'
        },{
            code: 'WG4',
            name: 'Model Code for States'
        }].map((group) => {
            group.people = [];
            return group;
        });

        let codes = vm.groups.map((group) => {
            return group.code;
        });


        vm.people
            .map((person) => {
                let category = person.Category.match(/ [A-E][1-9]/);

                if (category) {
                    person.category = category[0].trim();
                }
                else {
                    person.category = 'E';
                }


                if (person.category == 'A7') {
                    person.category = 'E';
                }
/*
                if (person.category[0] == 'A' && person.category != 'A1') {
                    person.category = 'E';
                }*/
/*
                if (person.category == 'D4') {
                    person.category = 'E';
                }

                if (person.Organization == 'National Grange') {
                    person.category = 'E';
                }
*/
                person.color = COLORS[categories.indexOf(person.category[0])];

                return person;
            })
            .sort((a,b) => {
                if (a.category < b.category) {
                    return -1;
                }
                else if (a.category > b.category) {
                    return 1
                }
                return 0;
            })
            .map((person) => {
                person.groups = person['Working Groups']
                                    .split(',')
                                    .map((group) => group.trim())
                                    .filter((group) => group !== '');

                if (person.BDAC == 'TRUE') {
                    person.groups.push('BDAC');
                }

                person.groups = person.groups
                        .map((code) => vm.groups[codes.indexOf(code)]);
                    
                person.groups.forEach((group) => group.people.push(person));

                return person;
            });

    }
};



// WEBPACK FOOTER //
// ./src/script/view/people.js